/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface IsothermType {
}

export enum IsothermType_Enum {
  kAbove = 0,
  kBelow = 1,
  kIncludeInterval = 2,
  kExcludeInterval = 3,
  UNRECOGNIZED = -1,
}

export function isothermType_EnumFromJSON(object: any): IsothermType_Enum {
  switch (object) {
    case 0:
    case "kAbove":
      return IsothermType_Enum.kAbove;
    case 1:
    case "kBelow":
      return IsothermType_Enum.kBelow;
    case 2:
    case "kIncludeInterval":
      return IsothermType_Enum.kIncludeInterval;
    case 3:
    case "kExcludeInterval":
      return IsothermType_Enum.kExcludeInterval;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IsothermType_Enum.UNRECOGNIZED;
  }
}

export function isothermType_EnumToJSON(object: IsothermType_Enum): string {
  switch (object) {
    case IsothermType_Enum.kAbove:
      return "kAbove";
    case IsothermType_Enum.kBelow:
      return "kBelow";
    case IsothermType_Enum.kIncludeInterval:
      return "kIncludeInterval";
    case IsothermType_Enum.kExcludeInterval:
      return "kExcludeInterval";
    case IsothermType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseIsothermType(): IsothermType {
  return {};
}

export const IsothermType = {
  encode(_: IsothermType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IsothermType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIsothermType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): IsothermType {
    return {};
  },

  toJSON(_: IsothermType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<IsothermType>, I>>(base?: I): IsothermType {
    return IsothermType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IsothermType>, I>>(_: I): IsothermType {
    const message = createBaseIsothermType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
